export const organizationsQueryKeys = {
  all: ["organizations"] as const,
  list: (customerId: number | undefined) => [...organizationsQueryKeys.all, "list", customerId] as const,
};
